import { Grid, TextField } from '@mui/material'
import { RtwMaintenanceRequest } from '../../../../../../types/return-to-work'

type Props = {
  additionalComments: string
  onFieldChange: (field: keyof RtwMaintenanceRequest, value: any) => void
}

function CommentsSection({ additionalComments, onFieldChange }: Props) {
  return (
    <Grid item xs={12} mt={0}>
      <TextField
        id="further-comments"
        label="Further Comments"
        variant="outlined"
        value={additionalComments}
        onChange={(e) => onFieldChange('additionalComments', e.target.value)}
        rows={3}
        multiline
        fullWidth
      />
    </Grid>
  )
}

export default CommentsSection